// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/reset.css
// module id = 991W
// module chunks = 11